




























































































































import { Component, Mixins, Prop, Vue, Ref } from 'vue-property-decorator'
import EditDialogMixin from '@/common/dialogs/mixins/edit-dialog-mixin'
import ClientConfig from '@/clients/entities/client-config'

@Component
export default class ClientConfigDialog extends Mixins<
  EditDialogMixin<ClientConfig>
>(EditDialogMixin) {
  model = new ClientConfig()
}
